
<template>
  <div>
    <div class="form-row div-valign">
      <div class="form-group col-md-6">
        <label>
          เลขที่สัญญา
          <!-- <span class="text-white">PTTGC_2</span> -->
        </label>
        <input
          v-model="ctrNoExt"
          name="ctrNoExt"
          data-vv-as="เลขที่สัญญา"
          v-validate="{ required:true}"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"
          :class="{'input': true, 'is-danger': errors.has('ctrNoExt') }"
          type="text"
          class="form-control"
        >
        <span v-show="errors.has('ctrNoExt')" class="help is-danger">{{ errors.first('ctrNoExt') }}</span>
      </div>

      <div class="form-group col-md-6">
        <label>
          ชื่อสัญญา
        </label>
        <input
          v-model="ctrNameExt"
          name="ctrNameExt"
          data-vv-as="ชื่อสัญญา"
          v-validate="{ required:true}"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"
          :class="{'input': true, 'is-danger': errors.has('ctrNameExt') }"
          maxlength="200"
          type="text"
          class="form-control"
        >
        <span v-show="errors.has('ctrNameExt')" class="help is-danger">{{ errors.first('ctrNameExt') }}</span>
      </div>
      
      <div class="form-group col-md-6">
        <label>วันที่ลงสัญญา
          <!-- <span class="text-white">DEFAULT_2</span> -->
        </label>
        <br>
        <date-picker
          v-model="ctrDateExt"
          name="ctrDateExt"
          ref="ctrDateExt"
          format="DD/MM/YYYY"
          v-validate="{ required:true}"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"
          data-vv-as="วันที่ลงสัญญา"
          lang="th"
          :class="{'input': true, 'is-danger': errors.has('ctrDateExt') }"
          placeholder
        ></date-picker>
        <span v-show="errors.has('ctrDateExt')" class="help is-danger">{{ errors.first('ctrDateExt') }}</span>  
        
      </div>

      <div class="form-group col-md-12">
        <label>
          รายละเอียดโครงการ/รายละเอียดสัญญา
          <!-- <span class="text-white">PTTGC_2</span> -->
        </label>
        <input
          v-model="beneficiaryRemarkExt"
          name="beneficiaryRemarkExt"
          data-vv-as="รายละเอียดโครงการ/รายละเอียดสัญญา"
          v-validate="{ required:true}"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"

          :class="{'input': true, 'is-danger': errors.has('beneficiaryRemarkExt') }"
          type="text"
          maxlength="500"
          class="form-control"
        >
        <span v-show="errors.has('beneficiaryRemarkExt')" class="help is-danger">{{ errors.first('beneficiaryRemarkExt') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import moment from "moment";

export default {
  inject: ["$validator"],
  props: ["reqType","appVo","lgType"],
  components: {
    DatePicker
  },
  data() {
    return {
      ctrNoExt: "",
      ctrNameExt: "",
      ctrDateExt: "",
      beneficiaryRemarkExt: ""
      // reqType:this.reqType,
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){
      this.ctrNoExt = this.appVo.ctrNo;
      this.ctrNameExt = this.appVo.ctrName;
      this.ctrDateExt = moment(this.appVo.ctrDate, 'DD/MM/YYYY');
      this.beneficiaryRemarkExt = this.appVo.beneficiaryRemark;
    }
  },    
  watch: {
    ctrNoExt(newDate, oldDate) {
      this.$emit("childToParent", {
        ctrNo: this.ctrNoExt,
        ctrName: this.ctrNameExt,
        ctrDate: this.ctrDateExt,
        beneficiaryRemark: this.beneficiaryRemarkExt
      });
    },
    ctrNameExt(newDate, oldDate) {
      this.$emit("childToParent", {
        ctrNo: this.ctrNoExt,
        ctrName: this.ctrNameExt,
        ctrDate: this.ctrDate,
        beneficiaryRemark: this.beneficiaryRemarkExt
      });
    },
    ctrDateExt(newDate, oldDate) {
      this.$emit("childToParent", {
        ctrNo: this.ctrNoExt,
        ctrName: this.ctrNameExt,
        ctrDate: this.ctrDateExt,
        beneficiaryRemark: this.beneficiaryRemarkExt
      });
    },
    beneficiaryRemarkExt(newDate, oldDate) {
      this.$emit("childToParent", {
        ctrNo: this.ctrNoExt,
        ctrName: this.ctrNameExt,
        ctrDate: this.ctrDateExt,
        beneficiaryRemark: this.beneficiaryRemarkExt
      });
    }
  }
};
</script>
                          
